import { formatLanguageString } from '@itslearning/atlas/strings/format.js';

function resolveTerm(resourceData, term, isHE) {
    return isHE
        ? resourceData[`HE:${term}`] ?? resourceData[term]
        : resourceData[term];
}

function lang(langCache, resource, term, ...values) {
    const data = langCache.data;

    let resourceData = data.currentLang[resource] ?? {};
    let termValue = resolveTerm(resourceData, term, data.isHE);

    const tranlationMissing = !termValue;

    const defaultLangResource = data.defaultLang[resource] ?? {};

    if (tranlationMissing && data.currentCultureName === 'yo-NG' && !term.startsWith('::')) {
        const defaultTermValue = resolveTerm(defaultLangResource, term, data.isHE);
        const defaultValue = values && values.length
            ? formatLanguageString(defaultTermValue, ...values)
            : defaultTermValue;
        return `${defaultValue} (${term.toUpperCase()})`;
    }

    if (tranlationMissing) {
        termValue = resolveTerm(defaultLangResource, term, data.isHE);

        if (!termValue) {
            if (term.startsWith('::')) {
                console.warn(`Temporary term '${resource}:${term}'`)
                termValue = `_${term.replace('::', '')}_`;
            } else {
                console.error(`Unknown term '${resource}:${term}'`);
                return `<< ${term} >>`;
            }
        }
    }

    if (tranlationMissing && data.currentCultureName !== 'en-GB') {
        console.warn(`Translation missing for '${resource}:${term}'`);
    }

    return values && values.length
        ? formatLanguageString(termValue, ...values)
        : termValue;
}

export function createLanguageProvider(langCache, resource) {
    return (term, ...values) => {
        return lang(langCache, resource, term, ...values);
    };
}
